import inviteCodeRepository from '@/repositories/invite-code.repository';
import { useMutation } from '@tanstack/react-query';

export function useCheckInviteCode() {
  return useMutation({
    mutationFn: inviteCodeRepository.checkInviteCode,
  });
}
